import { t } from '@lingui/macro';
import { startOfDay, endOfDay, subDays, subMonths, subYears } from 'date-fns';

export enum RangeType {
  Last7Days = 'Last7Days',
  LastMonth = 'LastMonth',
  Last3Months = 'Last3Months',
}

export enum TimePeriodType {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  Year = 'Year',
  All = 'All',
}

export const TimePeriodOptionsFn = (): Record<TimePeriodType, { label: string; range: [Date, Date] }> => ({
  [TimePeriodType.Day]: {
    label: t`Last 24 hours`,
    range: [subDays(new Date(), 1), endOfDay(new Date())],
  },
  [TimePeriodType.Week]: {
    label: t`Last 7 days`,
    range: [startOfDay(subDays(new Date(), 7)), endOfDay(new Date())],
  },
  [TimePeriodType.Month]: {
    label: t`Last month`,
    range: [startOfDay(subMonths(new Date(), 1)), endOfDay(new Date())],
  },
  [TimePeriodType.Quarter]: {
    label: t`Last 3 months`,
    range: [startOfDay(subMonths(new Date(), 3)), endOfDay(new Date())],
  },
  [TimePeriodType.Year]: {
    label: t`Last year`,
    range: [startOfDay(subYears(new Date(), 1)), endOfDay(new Date())],
  },
  [TimePeriodType.All]: {
    label: t`All data`,
    range: [startOfDay(subYears(new Date(), 10)), endOfDay(new Date())],
  },
});

export const mapRangeTypeToTimePeriod = (rt: RangeType): TimePeriodType => {
  switch (rt) {
    case RangeType.Last7Days:
      return TimePeriodType.Week;
    case RangeType.LastMonth:
      return TimePeriodType.Month;
    case RangeType.Last3Months:
      return TimePeriodType.Quarter;
    default:
      return TimePeriodType.Week;
  }
};
